var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrappoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 640,
    viewBox: "0 0 1440 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 640
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 640,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.326,
    y: 227.799,
    width: 120,
    height: 997.881,
    transform: "rotate(60 461.326 227.799)",
    fill: "url(#paint0_linear_122_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.17 -24.4167C1497.41 5.44226 1502.08 40.9264 1493.15 74.2298C1484.23 107.533 1462.44 135.928 1432.58 153.167C1402.72 170.406 1367.24 175.077 1333.94 166.154C1300.63 157.23 1272.24 135.442 1255 105.583L1367.58 40.5833L1480.17 -24.4167Z",
    fill: "url(#paint1_linear_122_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526 488C1526 519.826 1513.36 550.348 1490.85 572.853C1468.35 595.357 1437.83 608 1406 608C1374.17 608 1343.65 595.357 1321.15 572.853C1298.64 550.348 1286 519.826 1286 488L1334 488C1334 507.096 1341.59 525.409 1355.09 538.912C1368.59 552.414 1386.9 560 1406 560C1425.1 560 1443.41 552.414 1456.91 538.912C1470.41 525.409 1478 507.096 1478 488H1526Z",
    fill: "url(#paint2_linear_122_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_5",
    x1: 521.326,
    y1: 574.558,
    x2: 521.326,
    y2: 1225.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_5",
    x1: 1275.28,
    y1: 122.05,
    x2: 1443.42,
    y2: 122.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35068C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_122_5",
    x1: 1294.61,
    y1: 510.526,
    x2: 1429.02,
    y2: 588.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrappoBg);
export default __webpack_public_path__ + "static/media/crappo-bg.938d7b7732430e9e6da9a73f4b729ba6.svg";
export { ForwardRef as ReactComponent };